// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.faqSection_zrPEQ {
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  width: 100%;
  height: fit-content !important;
  max-height: fit-content !important;
  h2 {
    font-size: clamp(30px, 5vw, 40px) !important;
    font-weight: 300;
    color: #18181b;
    text-align: center;
  }
}

.faqContainer_vknnO {
  width: 100%;
  max-width: 750px;
  margin: 0 auto;
  font-family: Arial, sans-serif;
  padding: 40px 20px;
  padding-top: 20px;
  background-color: var(--white-color);
  border-radius: 15px;
  -webkit-border-radius: 15px;
  -moz-border-radius: 15px;
  -ms-border-radius: 15px;
  -o-border-radius: 15px;
  box-sizing: border-box;
  button {
    background-color: var(--white-color);
  }
}

.faqItem_GEeu5 {
  margin-bottom: 15px;
  border-radius: 5px;
  overflow: hidden;
  transition: all 0.3s ease-in-out;
}

.faqQuestion_ftj3s {
  width: 100%;
  background-color: var(--white-color);
  border: none;
  padding: 15px;
  text-align: left;
  font-size: 16px;
  font-weight: bold;
  cursor: pointer;
  display: flex;
  justify-content: space-between;
  align-items: center;
  span {
    color: var(--_2-color);
    font-weight: 300;
    img{
      width: 20px;
      height: 20px;
    }
  }
}

.icon_PGEQk {
  font-size: 14px;
  transition: transform 0.3s ease;
  transform: rotate(180deg);
  -webkit-transform: rotate(180deg);
  -moz-transform: rotate(180deg);
  -ms-transform: rotate(180deg);
  -o-transform: rotate(180deg);
}

.icon_PGEQk.open_dZe5a {
  transform: rotate(0deg);
  -webkit-transform: rotate(0deg);
  -moz-transform: rotate(0deg);
  -ms-transform: rotate(0deg);
  -o-transform: rotate(0deg);
}

.faqAnswer_mBwfK {
  max-height: 0;
  overflow: hidden;
  padding: 0 15px;
  color: var(--_10a37f-background);
  font-size: 14px;
  font-weight: 500;
  line-height: 1.6;
  transition:
    max-height 0.3s ease-in-out,
    padding 0.3s ease-in-out;
  border-bottom: 1px solid #dcdcdc;
  background-color: var(--white-color);
  -webkit-transition:
    max-height 0.3s ease-in-out,
    padding 0.3s ease-in-out;
  -moz-transition:
    max-height 0.3s ease-in-out,
    padding 0.3s ease-in-out;
  -ms-transition:
    max-height 0.3s ease-in-out,
    padding 0.3s ease-in-out;
  -o-transition:
    max-height 0.3s ease-in-out,
    padding 0.3s ease-in-out;
}

.faqAnswer_mBwfK.show_JTuGe {
  max-height: 1000px;

  padding: 15px;
}

.contact_dlidD {
  display: flex;
  align-items: center;
  gap: 15px;
  padding: 20px 0;
  margin: 0;
  margin-left: 5px;
  font-weight: 500;
  a {
    color: var(--_16c098-color);
    text-decoration: none;
    font-weight: 700;
    display: flex;
    align-items: center;
    justify-content: center;
    width: fit-content;
    gap: 10px;
    img {
      width: 18px;
    }
  }
}

@media (max-width: 768px) {
  .faqContainer_vknnO {
    border: none;
  }
}
`, "",{"version":3,"sources":["webpack://./src/views/Dashboard/components/Faqs/Faqs.module.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,sBAAsB;EACtB,WAAW;EACX,8BAA8B;EAC9B,kCAAkC;EAClC;IACE,4CAA4C;IAC5C,gBAAgB;IAChB,cAAc;IACd,kBAAkB;EACpB;AACF;;AAEA;EACE,WAAW;EACX,gBAAgB;EAChB,cAAc;EACd,8BAA8B;EAC9B,kBAAkB;EAClB,iBAAiB;EACjB,oCAAoC;EACpC,mBAAmB;EACnB,2BAA2B;EAC3B,wBAAwB;EACxB,uBAAuB;EACvB,sBAAsB;EACtB,sBAAsB;EACtB;IACE,oCAAoC;EACtC;AACF;;AAEA;EACE,mBAAmB;EACnB,kBAAkB;EAClB,gBAAgB;EAChB,gCAAgC;AAClC;;AAEA;EACE,WAAW;EACX,oCAAoC;EACpC,YAAY;EACZ,aAAa;EACb,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,eAAe;EACf,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB;IACE,sBAAsB;IACtB,gBAAgB;IAChB;MACE,WAAW;MACX,YAAY;IACd;EACF;AACF;;AAEA;EACE,eAAe;EACf,+BAA+B;EAC/B,yBAAyB;EACzB,iCAAiC;EACjC,8BAA8B;EAC9B,6BAA6B;EAC7B,4BAA4B;AAC9B;;AAEA;EACE,uBAAuB;EACvB,+BAA+B;EAC/B,4BAA4B;EAC5B,2BAA2B;EAC3B,0BAA0B;AAC5B;;AAEA;EACE,aAAa;EACb,gBAAgB;EAChB,eAAe;EACf,gCAAgC;EAChC,eAAe;EACf,gBAAgB;EAChB,gBAAgB;EAChB;;4BAE0B;EAC1B,gCAAgC;EAChC,oCAAoC;EACpC;;4BAE0B;EAC1B;;4BAE0B;EAC1B;;4BAE0B;EAC1B;;4BAE0B;AAC5B;;AAEA;EACE,kBAAkB;;EAElB,aAAa;AACf;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,eAAe;EACf,SAAS;EACT,gBAAgB;EAChB,gBAAgB;EAChB;IACE,2BAA2B;IAC3B,qBAAqB;IACrB,gBAAgB;IAChB,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,kBAAkB;IAClB,SAAS;IACT;MACE,WAAW;IACb;EACF;AACF;;AAEA;EACE;IACE,YAAY;EACd;AACF","sourcesContent":[".faqSection {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  flex-direction: column;\n  width: 100%;\n  height: fit-content !important;\n  max-height: fit-content !important;\n  h2 {\n    font-size: clamp(30px, 5vw, 40px) !important;\n    font-weight: 300;\n    color: #18181b;\n    text-align: center;\n  }\n}\n\n.faqContainer {\n  width: 100%;\n  max-width: 750px;\n  margin: 0 auto;\n  font-family: Arial, sans-serif;\n  padding: 40px 20px;\n  padding-top: 20px;\n  background-color: var(--white-color);\n  border-radius: 15px;\n  -webkit-border-radius: 15px;\n  -moz-border-radius: 15px;\n  -ms-border-radius: 15px;\n  -o-border-radius: 15px;\n  box-sizing: border-box;\n  button {\n    background-color: var(--white-color);\n  }\n}\n\n.faqItem {\n  margin-bottom: 15px;\n  border-radius: 5px;\n  overflow: hidden;\n  transition: all 0.3s ease-in-out;\n}\n\n.faqQuestion {\n  width: 100%;\n  background-color: var(--white-color);\n  border: none;\n  padding: 15px;\n  text-align: left;\n  font-size: 16px;\n  font-weight: bold;\n  cursor: pointer;\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  span {\n    color: var(--_2-color);\n    font-weight: 300;\n    img{\n      width: 20px;\n      height: 20px;\n    }\n  }\n}\n\n.icon {\n  font-size: 14px;\n  transition: transform 0.3s ease;\n  transform: rotate(180deg);\n  -webkit-transform: rotate(180deg);\n  -moz-transform: rotate(180deg);\n  -ms-transform: rotate(180deg);\n  -o-transform: rotate(180deg);\n}\n\n.icon.open {\n  transform: rotate(0deg);\n  -webkit-transform: rotate(0deg);\n  -moz-transform: rotate(0deg);\n  -ms-transform: rotate(0deg);\n  -o-transform: rotate(0deg);\n}\n\n.faqAnswer {\n  max-height: 0;\n  overflow: hidden;\n  padding: 0 15px;\n  color: var(--_10a37f-background);\n  font-size: 14px;\n  font-weight: 500;\n  line-height: 1.6;\n  transition:\n    max-height 0.3s ease-in-out,\n    padding 0.3s ease-in-out;\n  border-bottom: 1px solid #dcdcdc;\n  background-color: var(--white-color);\n  -webkit-transition:\n    max-height 0.3s ease-in-out,\n    padding 0.3s ease-in-out;\n  -moz-transition:\n    max-height 0.3s ease-in-out,\n    padding 0.3s ease-in-out;\n  -ms-transition:\n    max-height 0.3s ease-in-out,\n    padding 0.3s ease-in-out;\n  -o-transition:\n    max-height 0.3s ease-in-out,\n    padding 0.3s ease-in-out;\n}\n\n.faqAnswer.show {\n  max-height: 1000px;\n\n  padding: 15px;\n}\n\n.contact {\n  display: flex;\n  align-items: center;\n  gap: 15px;\n  padding: 20px 0;\n  margin: 0;\n  margin-left: 5px;\n  font-weight: 500;\n  a {\n    color: var(--_16c098-color);\n    text-decoration: none;\n    font-weight: 700;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    width: fit-content;\n    gap: 10px;\n    img {\n      width: 18px;\n    }\n  }\n}\n\n@media (max-width: 768px) {\n  .faqContainer {\n    border: none;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"faqSection": `faqSection_zrPEQ`,
	"faqContainer": `faqContainer_vknnO`,
	"faqItem": `faqItem_GEeu5`,
	"faqQuestion": `faqQuestion_ftj3s`,
	"icon": `icon_PGEQk`,
	"open": `open_dZe5a`,
	"faqAnswer": `faqAnswer_mBwfK`,
	"show": `show_JTuGe`,
	"contact": `contact_dlidD`
};
export default ___CSS_LOADER_EXPORT___;
